import React from 'react';
import { CTAButton } from './CTAButton';
import { Countdown } from './Countdown';
const pillars = ['Anatomy', 'Color', 'Layering', 'Texture', 'Finishing'];
export function FinalCTA() {
  return <section className="w-full bg-brand-900 px-4 py-14 pb-28 sm:px-6 sm:py-20 sm:pb-28" data-id="element-143" data-mp="c7aew89tyci4">
      <div className="mx-auto max-w-2xl" data-id="element-144" data-mp="85fd72nzlx3t">
        <h2 className="text-center font-display text-[26px] font-bold leading-tight text-white sm:text-4xl" data-id="element-145" data-mp="83m5dk1n16u8">
          🦷 Ready to stop guessing and start analyzing your veneers with a system?
        </h2>
        <p className="mt-4 text-center text-[15px] leading-relaxed text-brand-100" data-id="element-146" data-mp="h5c6jhlbnk57">
          Start today using a visual framework built around:
        </p>

        <ul className="mt-6 grid grid-cols-2 gap-2 sm:grid-cols-5" data-id="element-147" data-mp="qv59ju7eeqxu">
          {pillars.map(pillar => <li key={pillar} className="rounded-xl bg-white/10 px-2 py-3 text-center text-[12px] font-extrabold uppercase tracking-[0.08em] text-white ring-1 ring-white/15 last:col-span-2 sm:last:col-span-1" data-id="element-148" data-mp="14uogwksdxy93">
              {pillar}
            </li>)}
        </ul>

        <p className="mt-6 text-center text-[15px] font-semibold text-brand-100" data-id="element-149" data-mp="2h4j0kvrghop5">
          And analyze your key veneer decisions in under 15 minutes.
        </p>

        <div className="mt-8" data-id="element-150" data-mp="2r1nrf8w8y8ca">
          <CTAButton label="Get the Natural Veneer Blueprint" data-id="element-151" data-mp="2r2yv78pozg3e" />
          <p className="mt-3 text-center text-[12.5px] font-medium text-brand-200" data-id="element-152" data-mp="2v3setpw3q8qh">
            Just $27 · Instant Access · Lifetime Access · 7-Day Guarantee
          </p>
        </div>

        <div className="mt-9 rounded-2xl bg-white/[0.06] px-4 py-6 ring-1 ring-white/10" data-id="element-153" data-mp="34tc0f3b78gp1">
          <Countdown tone="dark" data-id="element-154" data-mp="34vofn8pkocye" />
          <p className="mt-3 text-center text-[13px] font-semibold text-brand-100" data-id="element-155" data-mp="39syfzjei2910">
            🔥 Get instant access at the special launch price.
          </p>
          <p className="mt-2 text-center text-[12.5px] font-medium text-brand-200" data-id="element-156" data-mp="3eporruj9uigm">
            💱 Currency conversion is automatically handled based on your country.
          </p>
        </div>
      </div>
    </section>;
}